import { FC, lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper2 } from '../pages/dashboard/DashboardWrapper2'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import { Participant } from "../pages/Participant/list/Participant"
import { EditParticipant } from "../pages/Participant/edit/Participant"
import { Banner } from "../pages/Banner/list/Banner"
import { PrivilegeList } from "../pages/Privilege/list/Privilege"
import { HistoryBurn } from "../pages/Transaction/list/HistoryBurn"
import { HistoryEarn } from "../pages/Transaction/list/HistoryEarn"
import { AddPoint } from "../pages/AddPoint/edit/AddPoint"
import { CreatePrivilege } from "../pages/Privilege/create/CreatePrivilege"
import { EditPrivilege } from "../pages/Privilege/edit/EditPrivilege"
import { CreateBanner } from "../pages/Banner/create/CreateBanner"
import { EditBanner } from "../pages/Banner/edit/EditBanner"
import { ParticipantVerify } from "../pages/Participant/list/ParticipantVerify"
import { Report } from "../pages/Report/list/Report"

import { CreateSurvey } from "../pages/MargetingCenter/create/CreateSurvey"
import { TierManagement } from "../pages/UserManagement/list/TierManagement"
import { TargetGroupManagement } from "../pages/UserManagement/list/TargetGroupManagement"
import { Management } from "../pages/UserManagement/list/Management"
import { ReportUser } from '../pages/Report/list/ReportUser'
import { PointEarn } from '../pages/Report/list/PointEarn'
import { RedeemHistory } from '../pages/Report/list/RedeemHistory'
import { CampaignPerformanace } from '../pages/Report/list/CampaignPerformanace'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper2 />} />
        <Route path="/Participant" element={<Participant />} />
        <Route path="/EditParticipant" element={<EditParticipant />} />
        <Route path="/Banner" element={<Banner />} />
        <Route path="/PrivilegeList" element={<PrivilegeList />} />
        <Route path="/HistoryBurn" element={<HistoryBurn />} />
        <Route path="/HistoryEarn" element={<HistoryEarn />} />
        <Route path="/AddPoint" element={<AddPoint />} />
        <Route path="/CreatePrivilege" element={<CreatePrivilege />} />
        <Route path="/VerifyParticipant" element={<ParticipantVerify />} />
        <Route path="/Report" element={<Report />} />
        <Route path="/Userreport" element={<ReportUser />} />
        <Route path="/Pointearn" element={<PointEarn />} />
        <Route path="/Redeem" element={<RedeemHistory />} />
        <Route path="/Campaignrp" element={<CampaignPerformanace />} />
        <Route path="/CreateSurvey" element={<CreateSurvey />} />
        <Route path="/TierManagement" element={<TierManagement />} />
        <Route path="/TargetGroupManagement" element={<TargetGroupManagement />} />
        <Route path="/Management" element={<Management />} />

        <Route path="/CreateSurvey" element={<CreateSurvey  />} />
        <Route path="/TierManagement" element={<TierManagement  />} />
        <Route path="/TargetGroupManagement" element={<TargetGroupManagement  />} />
        <Route path="/Management" element={<Management  />} />
        <Route path="/CreateBanner" element={<CreateBanner  />} />
        <Route path="/EditBanner" element={<EditBanner  />} />
        <Route path="/EditPrivilege" element={<EditPrivilege  />} />
        
        <Route
          path='builder'
          element={
            <SuspensedView>
              <BuilderPageWrapper />
            </SuspensedView>
          }
        />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
